import * as React from "react"

export default () : JSX.Element => (
  <div className='box box--purple box--point box--large hide-on-mobile'>
    <div className='box__point'></div>
    <div className='box__body'>
      <h1 className='hero__title hero__title--home' dangerouslySetInnerHTML={{ __html: I18n.t('header') }} />
    </div>
  </div>
)
